/* eslint-disable */

import { React, useState } from "react";
import Body from "./Body";
import profileImg from "../../../../assets/Images/TestImg/profileImage.png";

const Dashboard = () => {
  const [overViewCardData, setOverViewCardData] = useState([
    {
      title: "Members",
      presentCount: "12",
      totalCount: "20",
      cardType: "regular",
      bgColor: "#EEEAFF",
    },
    {
      title: "Total Meetings",
      presentCount: "12",
      totalCount: "20",
      cardType: "regular",
      bgColor: "rgba(154, 156, 1, 0.17)",
    },
    {
      title: "Staffs",
      presentCount: "12",
      totalCount: "20",
      cardType: "regular",
      bgColor: "#FEE0FF",
    },
    {
      title: "Events",
      presentCount: "12",
      totalCount: "20",
      cardType: "regular",
      bgColor: "#DFFFE8",
    },
    {
      title: "Tokens",
      presentCount: "56",
      totalCount: "258",
      cardType: "small",
      bgColor: "#5E4DE1",
    },
  ]);

  const [lineChartData, setLineChartData] = useState([
    { name: "Jan", members: 40, staffs: 20 },
    { name: "Feb", members: 45, staffs: 22 },
    { name: "Mar", members: 50, staffs: 25 },
    { name: "Apr", members: 70, staffs: 28 },
    { name: "May", members: 70, staffs: 56 },
    { name: "June", members: 60, staffs: 45 },
    { name: "July", members: 56, staffs: 23 },
    { name: "Aug", members: 35, staffs: 78 },
    { name: "Sept", members: 29, staffs: 97 },
    { name: "Oct", members: 59, staffs: 34 },
    { name: "Nov", members: 14, staffs: 76 },
  ]);

  const [upcomingEventsData, setUpcomingEventsData] = useState([
    {
      eventName: "Guardian Meeting",
      eventDate: "2025/02/03",
      eventDay: "Today",
    },
    {
      eventName: "Guardian Meeting",
      eventDate: "2025/02/16-2025/02/17",
      eventDay: "Today",
    },
    {
      eventName: "Guardian Meeting",
      eventDate: "2025/02/03",
      eventDay: "Today",
    },
    {
      eventName: "Guardian Meeting",
      eventDate: "2025/02/03",
      eventDay: "Today",
    },
    {
      eventName: "Guardian Meeting",
      eventDate: "2025/02/03",
      eventDay: "Today",
    },
    {
      eventName: "Guardian Meeting",
      eventDate: "2025/02/03",
      eventDay: "Today",
    },
    {
      eventName: "Guardian Meeting",
      eventDate: "2025/02/03",
      eventDay: "Today",
    },

  ]);

  const [upcomingMeetingsData, setUpcomingMeetingsData] = useState([
    {
      meetingName: "Riyaz Hossain",
      meetingDate: "2025/02/03",
      meetingAttendee: "Chemistry Teacher",
      eventDate: "2025/02/03",
    },
    {
      meetingName: "Riyaz Hossain",
      meetingDate: "2025/02/03",
      meetingAttendee: "Chemistry Teacher",
      eventDate: "2025/02/03",
    },
    {
      meetingName: "Riyaz Hossain",
      meetingDate: "2025/02/03",
      meetingAttendee: "Chemistry Teacher",
      eventDate: "2025/02/03",
    },
    {
      meetingName: "Riyaz Hossain",
      meetingDate: "2025/02/03",
      meetingAttendee: "Chemistry Teacher",
      eventDate: "2025/02/03",
    },
    {
      meetingName: "Riyaz Hossain",
      meetingDate: "2025/02/03",
      meetingAttendee: "Chemistry Teacher",
      eventDate: "2025/02/03",
    },
    {
      meetingName: "Riyaz Hossain",
      meetingDate: "2025/02/03",
      meetingAttendee: "Chemistry Teacher",
      eventDate: "2025/02/03",
    },
    {
      meetingName: "Riyaz Hossain",
      meetingDate: "2025/02/03",
      meetingAttendee: "Chemistry Teacher",
      eventDate: "2025/02/03",
    },
    {
      meetingName: "Riyaz Hossain",
      meetingDate: "2025/02/03",
      meetingAttendee: "Chemistry Teacher",
      eventDate: "2025/02/03",
    },
    {
      meetingName: "Riyaz Hossain",
      meetingDate: "2025/02/03",
      meetingAttendee: "Chemistry Teacher",
      eventDate: "2025/02/03",
    },
    {
      meetingName: "Riyaz Hossain",
      meetingDate: "2025/02/03",
      meetingAttendee: "Chemistry Teacher",
      eventDate: "2025/02/03",
    },
    {
      meetingName: "Riyaz Hossain",
      meetingDate: "2025/02/03",
      meetingAttendee: "Chemistry Teacher",
      eventDate: "2025/02/03",
    },
    {
      meetingName: "Riyaz Hossain",
      meetingDate: "2025/02/03",
      meetingAttendee: "Chemistry Teacher",
      eventDate: "2025/02/03",
    },
    {
      meetingName: "Riyaz Hossain",
      meetingDate: "2025/02/03",
      meetingAttendee: "Chemistry Teacher",
      eventDate: "2025/02/03",
    },
    {
      meetingName: "Riyaz Hossain",
      meetingDate: "2025/02/03",
      meetingAttendee: "Chemistry Teacher",
      eventDate: "2025/02/03",
    },

  ]);
  const [donutChartData, setDonutChartData] = useState([
    {
      participant: "Members",
      appearanceCount: 15,
      totalAttendee: 30,
      positionColor: "rgba(20, 184, 166, 0.56)",
    },
    {
      participant: "Secretary",
      appearanceCount: 21,
      totalAttendee: 30,
      positionColor: "rgba(59, 130, 246, 0.56)",
    },
    {
      participant: "President",
      appearanceCount: 12,
      totalAttendee: 30,
      positionColor: "rgba(99, 102, 241, 0.56)",
    },
    {
      participant: "Asst. Secretary",
      appearanceCount: 7,
      totalAttendee: 30,
      positionColor: "rgba(236, 72, 153, 0.56)",
    },
    {
      participant: "Cashier",
      appearanceCount: 28,
      totalAttendee: 30,
      positionColor: "rgba(245, 158, 11, 0.56)",
    },
    {
      participant: "Vice President",
      appearanceCount: 27,
      totalAttendee: 30,
      positionColor: "rgba(250, 204, 21, 0.56)",
    },
  ]);

  const [importantAppearanceData,setImportantAppearanceData]=useState([
    {
      personName: "Riyaz Hossain",
      personId: "HG56372",
      designation: "Chemistry Teacher",
      appearToday: "No",
      image: profileImg
    },
    {
      personName: "Riyaz Hossain",
      personId: "HG56372",
      designation: "Chemistry Teacher",
      appearToday: "Yes",
      image: profileImg
    },
    {
      personName: "Riyaz Hossain",
      personId: "HG56372",
      designation: "Chemistry Teacher",
      appearToday: "No",
      image: profileImg
    },
    {
      personName: "Riyaz Hossain",
      personId: "HG56372",
      designation: "Chemistry Teacher",
      appearToday: "Yes",
      image: profileImg
    },
    {
      personName: "Riyaz Hossain",
      personId: "HG56372",
      designation: "Chemistry Teacher",
      appearToday: "Yes",
      image: profileImg
    },
    {
      personName: "Riyaz Hossain",
      personId: "HG56372",
      designation: "Chemistry Teacher",
      appearToday: "Yes",
      image: profileImg
    },
    {
      personName: "Riyaz Hossain",
      personId: "HG56372",
      designation: "Chemistry Teacher",
      appearToday: "Yes",
      image: profileImg
    },
    {
      personName: "Riyaz Hossain",
      personId: "HG56372",
      designation: "Chemistry Teacher",
      appearToday: "Yes",
      image: profileImg
    },
    {
      personName: "Riyaz Hossain",
      personId: "HG56372",
      designation: "Chemistry Teacher",
      appearToday: "No",
      image: profileImg
    }
  ]);
  const _this = {
    overViewCardData,
    lineChartData,
    upcomingEventsData,
    upcomingMeetingsData,
    donutChartData,importantAppearanceData
  };
  return <Body {..._this} />;
};

export default Dashboard;
